import { create } from "zustand";
import { getCallingKpiFilter, getCallingKpiFilterApply, getEngagementData, getKpiHistoryData, getKpiHistoryFilter, getUserData, RESPONSE, RESPONSE_FILTER } from "../api";
import { toast } from "react-toastify";

export const useCallingKpi = create((set) => ({
  tableData: {
    headers: [],
    total_row_count: 0,
    page_number: 1,
    page_size: 10,
    view_type: "",
    is_downloadable: false,
    rows_data: [],
    others: {}
  },

  tableDataLoading: false,
  tableDataError: null,

  filterData: [],
  filterDataLoading: false,
  filterDataError: null,

  engagementData: {
    headers: [],
    total_row_count: 0,
    page_number: 1,
    page_size: 10,
    view_type: "",
    is_downloadable: false,
    rows_data: [],
    others: {}
  },
  engagementDataLoading: false,
  engagementDataError: null,
  
  userData: {
    headers: [],
    total_row_count: 0,
    page_number: 1,
    page_size: 10,
    view_type: "",
    is_downloadable: false,
    rows_data: [],
    others: {}
  },
  userDataLoading: false,
  userDataError: null,

  fetchCallingKpiFilters: async () => {
    try {
      set({ filterDataLoading: true });
      const response = await getCallingKpiFilter();
      set({ filterData: response.data.filters });
    } catch (error) {
      set({ filterDataError: error.message });
      toast.error(error.message);
    } finally {
      set({ filterDataLoading: false });
    }
  },

  fetchCallingKpiFilterApply: async (params, is_downloadable) => {
    try {
      set({ tableDataLoading: true });
      const response = await getCallingKpiFilterApply(params);
      if (!is_downloadable) {
        set({ tableData: response.data });
      } else {
        return response;
      }
    } catch (error) {
      set({ tableDataError: error.message });
      toast.error(error.message);
    } finally {
      set({ tableDataLoading: false });
    }
  },

  fetchEngagementData: async (employeeUrl) => {
    try {
      set({ engagementDataLoading: true });
      const response = await getEngagementData(employeeUrl);
      set({ engagementData: response.data });
    } catch (error) {
      set({ engagementDataError: error.message });
      toast.error(error.message);
    } finally {
      set({ engagementDataLoading: false });
    }
  },

  fetchDetailViewData: async (employeeUrl) => {
    try {
      set({ userDataLoading: true });
      const response = await getUserData(employeeUrl);
      set({ userData: response.data });
    } catch (error) {
      set({ userDataError: error.message });
      toast.error(error.message);
    } finally {
      set({ userDataLoading: false });
    }
  },

  kpiHistoryData: {
    headers: [],
    total_row_count: 0,
    page_number: 1,
    page_size: 10,
    view_type: "",
    is_downloadable: false,
    rows_data: [],
    others: {}
  },
  kpiHistoryLoading: false,
  kpiHistoryError: null,


  fetchKpiHistoryData: async (queryParams) => {
    try {
      set({ kpiHistoryLoading: true });
      const response = await getKpiHistoryData(queryParams);
      set({ kpiHistoryData: response.data });
    } catch (error) {
      set({ kpiHistoryError: error.message });
      toast.error(error.message);
    } finally {
      set({ kpiHistoryLoading: false });
    }
  },

  kpiHistoryFilter: {
    filters: [],
  },
  kpiHistoryFilterLoading: false,
  kpiHistoryFilterError: null,

  fetchKpiHistoryFilter: async () => {
    try {
      set({ kpiHistoryFilterLoading: true });
      const response = await getKpiHistoryFilter();
      set({ kpiHistoryFilter: response.data });
    } catch (error) {
      set({ kpiHistoryFilterError: error.message });
      toast.error(error.message);
    } finally {
      set({ kpiHistoryFilterLoading: false });
    }
  },
}));